import MetaverseBackground from 'components/MetaverseBackground';
import StoryImage from 'components/StoryImage';
import TvOff from 'components/TvOff';
import AsciiTitle from 'components/AsciiTitle';
import Play from 'components/Play';

// Components usable inline in story text, e.g. <MetaverseBackground />.
// Add a component by adding a key here (name must match the tag).
const storyComponents = {
  MetaverseBackground,
  Image: StoryImage,
  TvOff,
  AsciiTitle,
  Play
};

export default storyComponents;
